class CartLineItems extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.quantityInputs = this.querySelectorAll('input');

    this.handleQuantityUpdate = this.handleQuantityUpdate.bind(this);

    this.quantityInputs.forEach(input => {
      console.log(`Check input value: ${input.value}`)
      input.addEventListener('change', this.handleQuantityUpdate);
    });
  }

  disconnectedCallback() {
    this.quantityInputs.forEach(input => {
      input.removeEventListener('change', this.handleQuantityUpdate);
    });
  }

  handleQuantityUpdate(event) {
    const input = event.target;
    const quantity = parseInt(input.value);

    // Validate quantity
    if (isNaN(quantity) || quantity < 1) {
      input.value = 1;
      return;
    }

    console.log(`Check Quantity: ${input.value}`);

    // Submit the form
    const form = input.closest('form');
    form && form.submit();
  }
}

customElements.define('cart-line-items', CartLineItems);
